import { render, staticRenderFns } from "./MainImage.vue?vue&type=template&id=310a235f&scoped=true&"
import script from "./MainImage.vue?vue&type=script&lang=ts&"
export * from "./MainImage.vue?vue&type=script&lang=ts&"
import style0 from "./MainImage.vue?vue&type=style&index=0&id=310a235f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310a235f",
  null
  
)

export default component.exports